import {
  safeGetSessionStorageItem,
  safeRemoveSessionStorageItem,
  safeSetSessionStorageItem,
} from '@mc/browser-storage'

const STORAGE_KEY = 'mc_checkout_step'

export interface CheckoutStepBreadcrumb {
  step: string
  isGift: boolean
}

// Written as the flow advances on /checkout/payment, read on /checkout when the
// user arrives there by pressing back. sessionStorage rather than a referrer
// check because on a history traversal `document.referrer` is restored as it was
// when that entry was first created — it points at whatever preceded /checkout,
// not at the payment page the user just backed out of.
export const saveCheckoutStepBreadcrumb = (
  breadcrumb: CheckoutStepBreadcrumb,
) => {
  safeSetSessionStorageItem(STORAGE_KEY, JSON.stringify(breadcrumb))
}

export const readAndClearCheckoutStepBreadcrumb =
  (): CheckoutStepBreadcrumb | null => {
    const raw = safeGetSessionStorageItem(STORAGE_KEY)
    safeRemoveSessionStorageItem(STORAGE_KEY)

    if (!raw) return null

    try {
      const parsed = JSON.parse(raw) as Partial<CheckoutStepBreadcrumb>
      if (typeof parsed?.step !== 'string') return null

      return { step: parsed.step, isGift: !!parsed.isGift }
    } catch {
      return null
    }
  }

export const clearCheckoutStepBreadcrumb = () => {
  safeRemoveSessionStorageItem(STORAGE_KEY)
}
